import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, CircularProgress, InputAdornment } from '@material-ui/core';
import { cleanPacket } from '../../../redux/actions/jobcoinsPacketActions';
import { showSuccess } from '../../../redux/actions/snackbarActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import packetService from '../../../api/jobcoinsPacketService';

class JobcoinsPacketFormModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: null,
            idUser: '',
            totalCoins: '',
            price: '',
            bonusCoins: '',
            isSaving: false
        }

        this.setTotalCoins = this.setTotalCoins.bind(this);
        this.setPrice = this.setPrice.bind(this);
        this.setBonusCoins = this.setBonusCoins.bind(this);
        this.setPacketDetails = this.setPacketDetails.bind(this);
        this.savePacket = this.savePacket.bind(this);
    }

    setTotalCoins(event) {
        this.setState({
            totalCoins: event.target.value
        });
    }

    setPrice(event) {
        this.setState({
            price: event.target.value
        });
    }

    setBonusCoins(event) {
        this.setState({
            bonusCoins: event.target.value
        });
    }

    setPacketDetails() {
        if (this.props.selectedPacket) {
            const { id, idUser, totalCoins, bonusCoins, price } = this.props.selectedPacket;
            this.setState({
                id,
                idUser,
                bonusCoins,
                totalCoins,
                price
            });
        } else {
            this.setState({
                id: null,
                idUser: '',
                totalCoins: '',
                bonusCoins: '',
                price: ''
            });
        }
    }

    savePacket() {
        this.setState({
            isSaving: true
        });
        if (Boolean(this.state.id)) {
            packetService.updatePacket(this.state.id, this.state.price, this.state.totalCoins, this.state.bonusCoins)
                .then(() => {
                    this.props.hideModal();
                    this.setState({
                        isSaving: false
                    });
                    this.props.showSuccess('Packet updated successfully.');
                });
        } else {
            packetService.addPacket(this.state.price, this.state.totalCoins, this.state.bonusCoins)
                .then(() => {
                    this.props.hideModal();
                    this.setState({
                        isSaving: false
                    });
                    this.props.showSuccess('Packet created successfully.');
                });
        }
    }

    render() {
        const { id, price, totalCoins, bonusCoins } = this.state;
        const { showModal, hideModal } = this.props;

        const isEditing = Boolean(id);

        return (
            <Dialog onRendered={() => {
                this.setPacketDetails();
            }} open={showModal} onClose={hideModal} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{isEditing ? "Edit Jobcoins Packet details" : "Add a new Jobcoins Packet"}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="normal"
                        id="price"
                        InputProps={{
                            startAdornment: <InputAdornment position="start">US$</InputAdornment>,
                        }}
                        variant="outlined"
                        label="Packet's price (US$)"
                        type="number"
                        onChange={this.setPrice}
                        value={price}
                        fullWidth
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        id="jobcoins"
                        label="Packet's Jobcoins"
                        type="number"
                        onChange={this.setTotalCoins}
                        value={totalCoins}
                        fullWidth
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        id="bonus-coins"
                        label="Bonus Coins"
                        type="number"
                        onChange={this.setBonusCoins}
                        value={bonusCoins}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={hideModal}>Back</Button>
                    <Button color="primary" onClick={this.savePacket} disabled={this.state.isSaving}>
                        {isEditing ? "Save" : "Add"}
                    </Button>
                    {this.state.isSaving && <CircularProgress size={24} />}
                </DialogActions>
            </Dialog>
        );
    }
}


const mapStateToProps = store => ({
    packets: store.jobcoinsPacketState.packets,
    selectedPacket: store.jobcoinsPacketState.selectedPacket
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ cleanPacket, showSuccess }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(JobcoinsPacketFormModal);